/**
 * Small, pure formatting helpers shared by the media commands
 * (`images` / `videos`). No I/O — trivially unit-testable.
 *
 * @module
 */

/** The trailing path segment of a file path (posix or windows separators). */
export const baseName = (p: string): string => {
  const norm = p.replace(/[/\\]+$/, "")
  const sep = Math.max(norm.lastIndexOf("/"), norm.lastIndexOf("\\"))
  return sep < 0 ? norm : norm.slice(sep + 1)
}

/** Human-readable byte count, e.g. 1_500_000 → "1.4 MB". */
export const formatBytes = (bytes: number | null): string => {
  if (bytes === null) return "unknown size"
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  const mb = bytes / (1024 * 1024)
  return `${mb >= 10 ? Math.round(mb) : mb.toFixed(1)} MB`
}
